<meeting-scheduler-calendar-slug-card
  [calendarId]="personalCalendarId$ | async"
  [setInitial]="true"
  [disableButtonIfValueUnchanged]="true"
  [enableTracking]="enableTracking"
></meeting-scheduler-calendar-slug-card>

<mat-card class="settings-card" appearance="outlined">
  <mat-card-header>
    <mat-card-title>{{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CALENDAR_SETTINGS' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <meeting-scheduler-settings-calendar
      (calendarProviderSelected)="handleCalendarProvider($event)"
      [enableTracking]="enableTracking"
      [isGoogleConfigured]="isGoogleMeetConfigured()"
      [isMicrosoftConfigured]="isMicrosoftConfigured()"
    >
      <div class="action-cont">
        <div class="stepper-actions-column">
          @if (selectedCalendarProvider() === 'microsoft') {
            <meeting-scheduler-connect-with-microsoft-button
              [serviceKey]="SERVICE_KEYS.eventsAndMeetingsPageCalendarConnected"
              [primaryDisconnect]="false"
            ></meeting-scheduler-connect-with-microsoft-button>
          }
          @if (selectedCalendarProvider() === 'google') {
            <meeting-scheduler-connect-with-google-button
              [serviceKey]="SERVICE_KEYS.eventsAndMeetingsPageCalendarConnected"
              [primaryDisconnect]="false"
            ></meeting-scheduler-connect-with-google-button>
          }
        </div>
      </div>
    </meeting-scheduler-settings-calendar>

    <mat-divider class="setting-divider"></mat-divider>

    <meeting-scheduler-settings-meeting-app
      [serviceKey]="SERVICE_KEYS.eventsAndMeetingsPageConferencingConnected"
      [hostPreferences]="hostPreferences()"
      [isGoogleMeetConfigured]="isGoogleMeetConfigured()" 
      [isMicrosoftConfigured]="isMicrosoftConfigured()"
      [enableTracking]="enableTracking"
    >
      <div class="meeting-app-actions">
        @if (integrationsPageLink$ | async; as link) {
          <button [routerLink]="[link]" mat-raised-button color="primary" class="open-integration-settings-button">
            {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.OPEN_INTEGRATION_SETTINGS' | translate }}
          </button>
        }
      </div>
    </meeting-scheduler-settings-meeting-app>

  </mat-card-content>
</mat-card>

<mat-card class="settings-card" appearance="outlined">
  <mat-card-header>
    <mat-card-title>{{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.SCHEDULING_SETTINGS' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <meeting-scheduler-settings-availability-increment
      [preferredAvailabilityIncrement]="hostPreferences()?.availabilityIncrement"
      [enableTracking]="enableTracking"
    ></meeting-scheduler-settings-availability-increment>

    <mat-divider class="setting-divider"></mat-divider>

    <meeting-scheduler-settings-meeting-before-buffer-card
      [bufferDurationBeforeMeeting]="hostPreferences()?.bufferDurationBeforeMeeting"
      [enableTracking]="enableTracking"
    ></meeting-scheduler-settings-meeting-before-buffer-card>

    <mat-divider class="setting-divider"></mat-divider>

    <meeting-scheduler-settings-meeting-buffer-card
      [bufferDurationAfterMeeting]="hostPreferences()?.bufferDurationAfterMeeting"
      [enableTracking]="enableTracking"
    ></meeting-scheduler-settings-meeting-buffer-card>

    <mat-divider class="setting-divider"></mat-divider>

    <meeting-scheduler-settings-notice-time-card
      [noticeTime]="hostPreferences()?.noticeTime"
      [enableTracking]="enableTracking"
    ></meeting-scheduler-settings-notice-time-card>

    <mat-divider class="setting-divider"></mat-divider>

    <meeting-scheduler-settings-advanced-availability-card
      [timezone]="hostPreferences()?.timezone.id"
      [enableTracking]="enableTracking"
      currentView="settings"
    ></meeting-scheduler-settings-advanced-availability-card>

  </mat-card-content>
</mat-card>

@if (selectedCalendarProvider() === 'google' && isGoogleMeetConnected()) {
<meeting-scheduler-sales-coach-user-config-settings>
</meeting-scheduler-sales-coach-user-config-settings>
}